import type { SVGProps } from 'react';
const SvgIconInfoI = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <g fill="none">
      <path
        fill="#1A202C"
        d="M8.855 5.498a.854.854 0 1 1-1.709 0 .854.854 0 0 1 1.709 0m-.144 5.158a.71.71 0 1 1-1.422 0V7.84a.711.711 0 0 1 1.422 0z"
      />
      <path
        fill="#4C5F66"
        d="M8 1.846a6.154 6.154 0 1 0 0 12.308A6.154 6.154 0 0 0 8 1.846m3.578 9.732a5.06 5.06 0 0 1-7.186.03 5.06 5.06 0 0 1 .03-7.186 5.06 5.06 0 0 1 7.186-.03 5.06 5.06 0 0 1-.03 7.186"
      />
      <path
        fill="#1A202C"
        d="M8 1.846a6.154 6.154 0 1 0 0 12.308A6.154 6.154 0 0 0 8 1.846m3.578 9.732a5.06 5.06 0 0 1-7.186.03 5.06 5.06 0 0 1 .03-7.186 5.06 5.06 0 0 1 7.186-.03 5.06 5.06 0 0 1-.03 7.186"
      />
    </g>
  </svg>
);
export default SvgIconInfoI;
